module.exports = __webpack_public_path__ + "img/274290432_4718706148214450_1882310502889298265_n.fde99fdb.jpg";